import { Injectable } from '@angular/core';

export interface ReferralGroup {
  value: number;
  label: string;
}

export const REFERRAL_GROUPS: ReferralGroup[] = [
  { value: 1, label: 'I-MED' },
  { value: 2, label: 'Marina' },
  { value: 3, label: 'MRI-Now' },
  { value: 4, label: 'Laverty' },
  { value: 5, label: 'Medmate-Scripts' },
  { value: 6, label: 'Automed' },
  { value: 7, label: 'Cornerstone Radiology' },
  { value: 8, label: 'Cornerstone Pathology' },
];

@Injectable({ providedIn: 'root' })
export class ReferralGroupService {
  private selectedReferralGroup: number | null = null;
  setSelectedReferralGroup(value: number | null) { this.selectedReferralGroup = value; }
  getSelectedReferralGroup(): number | null {
    return this.selectedReferralGroup !== null ? Number(this.selectedReferralGroup) : null;
  }
}
